import React from 'react';
import '../styles/nextGeneration.scss';
import Carousel from '../components/Carousel';

const NextGeneration = ({ showArrow }) => {
  return (
    <div className="nextGeneration" id="generation">
      <h4 className="bold nextGeneration__text">The Next Generation</h4>
      <p className="copy">
        Meet the next generation of space engineers, astronauts, and explorers.
      </p>
      <Carousel showArrow={showArrow} />
    </div>
  );
};

export default NextGeneration;
